import MetaTags from "react-meta-tags";
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Modal,
  Table,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  CardTitle,
  Dropdown,
} from "reactstrap";

import { withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import avatar from "../../assets/images/users/avatar-1.jpg";
// actions

import * as url from "../../helpers/url_helper"
import axios from "axios";
import { HRConfig } from "helpers/backend_helper";
import LoadingOverlay from 'react-loading-overlay';
import ClimbingBoxLoader from "react-spinners/ClimbingBoxLoader";

const UserProfile = props => {
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [empNo, setEmpNo] = useState ('')
  const [name, setname] = useState("");
  const [idx, setidx] = useState(1);
  const [username, setUsername] = useState('');
  const [jobTitle, setJobTitle] = useState('')
  const [location, setLocation] = useState('')
  const [employementDate, setEmploymentDate] = useState('')
  const [socialSecurity, setSocialSecurity] = useState('')
  const [mobilePhoneNo, setMobilePhoneNo] = useState('')
  const [status, setStatus] = useState('')
  const [appraiser, setAppraiser] = useState('')
  const [fStatus, setFStatus] = useState('')
  const [gender, setGender] = useState('')
  const [birthday, setBirthday] = useState('')
  const [companyEmail, setCompanyEmail] = useState('')
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState('')
  const [firstName, setFirstName] = useState('')
  const [middleName, setMiddleName] = useState('')
  const [lastName, setLastName] = useState('')
  const [address, setAddress] = useState('')
  const [district, setDistrict] = useState('')
  const [postcode, setPostCode] = useState('')
  const [city, setCity] = useState('')
  const [country, setCountry] = useState('')
  const [maritalStatus, setMaritalStatus] = useState('')
  const [probationDueDate, setProbationDueDate] = useState('')
  const [extension, setExtension] = useState('')
  const [phoneNo, setPhoneNo] = useState('')
  const [initials, setInitials] = useState('')
  const [nextofkinname, setNextofKinName] = useState('')
  const [nextofkinrelationship, setNextofKinRelationship] = useState('')
  const [nextofKinHomePostalAddress, setNextofKinHomePostalAddress] = useState('')
  const [nextofKinOfficeAddress, setNextofKinOfficeAddress] = useState('')
  const [nextofKinPhysicalAddress, setNextofKinPhysicalAddress] = useState('')
  const [nextofPlaceofWork, setNextofPlaceofWork] = useState('')
  const [tin, setTIN] = useState('')
  const [nin, setNIN] = useState('')
  const [religion, setReligion] = useState('')
  const [religiondescription, setReligionDescription] = useState('')
  const [residence, setResidence] = useState('')
  const [phyLCZone, setPhyLCZone] = useState('')
  const [phyParish, setPhyParish] = useState('')
  const [subcounty, setSubcounty] = useState('')
  const [villageaddress, setVillageAddress] = useState('')
  const [villageparish, setVillageParish] = useState('')
  const [villSubcounty, setVillageSubcounty] = useState('')
  const [villagedistrict, setVillageDistrict] = useState('')
  const [customerNo, setCustomerNo] = useState('')
  const [departmentCode, setDepartmentCode] = useState('')
  const [nextofKinWorkPhone, setNextofKinWorkPhone] = useState('')
  const [activeCompany, setActiveCompany] = useState('')
  const [pDependants, setpDependants] = useState([])
  const [pQualifications, setpQualifications] = useState([])
  const [pWorkExperience, setpWorkExperience] = useState([])
  const [modal_dependants, setmodal_dependants] = useState(false);
  const [modal_qualifications, setmodal_qualifications] = useState(false);
  const [modal_workexperience, setmodal_workexperience] = useState(false);
  const [fullnames, setFullnames] = useState('')
  const [staffinitials, setstaffinitials] = useState('')

  const tog_dependants = () => {
    setmodal_dependants(!modal_dependants);
    removeBodyCss();
  }
  const tog_qualifications = () => {
    setmodal_qualifications(!modal_qualifications);
    removeBodyCss();
  }
  const tog_workexperience = () => {
    setmodal_workexperience(!modal_workexperience);
    removeBodyCss();
  }
  const removeBodyCss = () => {
    document.body.classList.add("no_padding");
  }
  const handleDependants = () =>{
    setIsLoading(true)
    axios.get(url.DEPENDANTS +"?$filter=employeeNo eq '" + empNo +"'&company="+ activeCompany, HRConfig).then((r)=>{
        setpDependants(r.data.value)
        setIsLoading(false)
        tog_dependants()
    }).catch((e)=>{
        console.log(e)
        setIsLoading(false)
    })
}
const handleQualifications = () =>{
  setIsLoading(true)
  axios.get(url.STAFFQUALIFICATIONS +"?$filter=employeeNo eq '" + empNo +"'&company="+ activeCompany, HRConfig).then((r)=>{
      setpQualifications(r.data.value)
      setIsLoading(false)
      tog_qualifications()
  }).catch((e)=>{
      console.log(e)
      setIsLoading(false)
  })
}
const handleWorkExperience = () =>{
  setIsLoading(true)
  axios.get(url.STAFFWORKEXPERIENCE +"?$filter=employeeNo eq '" + empNo +"'&company="+ activeCompany, HRConfig).then((r)=>{
      setpWorkExperience(r.data.value)
      setIsLoading(false)
      tog_workexperience()
  }).catch((e)=>{
      console.log(e)
      setIsLoading(false)
  })
}
const handleHRRelatedInformation = () =>{
  setIsLoading(true)
  axios.get(url.DEPENDANTS +"?$filter=employeeNo eq '" + {empNo} +"'&company="+ obj.activeCompany, HRConfig).then((r)=>{
      setAHistory(r.data.value)
      setIsLoading(false)
      tog_dependants()
  }).catch((e)=>{
      console.log(e)
      setIsLoading(false)
  })
}

  useEffect(() => {
    if (localStorage.getItem("authMildUser")) {
      const obj = JSON.parse(localStorage.getItem("authMildUser"));
      setname(obj.username);
      setidx(obj.uid);
      setUsername(obj.nav_username)
      setFullnames(obj.staffname)
      setActiveCompany(obj.activeCompany)
      setIsLoading(true)
      axios.get(url.EMPLOYEES2 + "?$filter=No eq '"+ obj.uid +"'&company="+ obj.activeCompany, HRConfig).then((r)=>{
        console.log(r)
        setIsLoading(false)
        setJobTitle(r.data.value[0].JobTitle)
        setLocation(r.data.value[0].GlobalDimension2Code)
        setEmploymentDate(r.data.value[0].EmploymentDate)
        setEmpNo(r.data.value[0].No)
        setSocialSecurity(r.data.value[0].SocialSecurityNo)
        setMobilePhoneNo(r.data.value[0].MobilePhoneNo)
        setStatus(r.data.value[0].Status)
        setAppraiser(r.data.value[0].Appraiser)
        setFStatus(r.data.value[0].FathersStatus)
        setBirthday(r.data.value[0].BirthDate)
        setCompanyEmail(r.data.value[0].CompanyEMail)
        setEmail(r.data.value[0].Email)
        setFirstName(r.data.value[0].FirstName)
        setMiddleName(r.data.value[0].MiddleName)
        setLastName(r.data.value[0].LastName)
        setPostCode(r.data.value[0].Post_Code) 
        setCity(r.data.value[0].City) 
        setCountry(r.data.value[0].Country_Region_Code)
        setDistrict(r.data.value[0].District_Code)
        setAddress(r.data.value[0].Address)
        setGender(r.data.value[0].Gender)
        setMaritalStatus(r.data.value[0].Marital_Status)
        setProbationDueDate(r.data.value[0].Probation_Due_Date)
        setExtension(r.data.value[0].Extension)
        setPhoneNo(r.data.value[0].PhoneNo)
        setInitials(r.data.value[0].Initials)
        setNextofKinName(r.data.value[0].Next_Of_Kin_Name)
        setNextofKinRelationship(r.data.value[0].Next_Of_Kin_Relationship)
        setNextofPlaceofWork(r.data.value[0].Place_Of_Work)
        setNextofKinHomePostalAddress(r.data.value[0].Home_Postal_Address)
        setNextofKinOfficeAddress(r.data.value[0].Office_Address)
        setNextofKinPhysicalAddress(r.data.value[0].Physical_Address)
        setNextofKinWorkPhone(r.data.value[0].Work_Phone)
        setTIN(r.data.value[0].TIN_No)
        setNIN(r.data.value[0].National_ID)
        setReligion(r.data.value[0].Religion)
        setReligionDescription(r.data.value[0].Religion_Description)
        setResidence(r.data.value[0].Residence)
        setPhyLCZone(r.data.value[0].Phy_LC_Zone)
        setPhyParish(r.data.value[0].Phy_Parish)
        setSubcounty(r.data.value[0].Subcounty)
        setVillageAddress(r.data.value[0].Village_Address)
        setVillageParish(r.data.value[0].Vill_Parish)
        setVillageSubcounty(r.data.value[0].Vill_Subcounty)
        setVillageDistrict(r.data.value[0].Vill_District)
        setDepartmentCode(r.data.value[0].Department_Code)
        setCustomerNo(r.data.value[0].Customer_No)
        setstaffinitials(obj.staffname.split(' ').reduce((acc, subname) => acc + subname[0], ''))
      }).catch((e)=>{
        setIsLoading(false)
        console.log(e)
      })
    }
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Profile | BRIDGE</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="User Management" breadcrumbItem="Profile" />

          <Modal isOpen={modal_dependants} toggle={() => { tog_dependants() }} centered size="xl">
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="myModalLabel">My Dependants</h5>
                <button
                  type="button"
                  onClick={() => {
                    setmodal_dependants(false);
                  }}
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">                                                       
              <Row >
                <Col lg={12}>
                  {(pDependants.length > 0) ? (
                    <div className="table-responsive">
                      <Table className="table table-sm m-0">
                        <thead>
                          <tr>
                              <th>Relative Code</th>
                              <th>First Name</th>
                              <th>Birth Date</th>
                              <th>Phone</th>
                              <th>Beneficiary</th>
                              <th>Beneficiary Percentage</th>
                              <th>Funeral Benefits</th>
                              <th>Alive/Deceased Name</th>
                          </tr>
                        </thead>
                          <tbody>
                              {pDependants.map((a,k)=>(
                                  <tr key={k}>
                                      <td>{a.relativeCode}</td>
                                      <td>{a.firstName}</td>
                                      <td>{a.birthDate}</td>
                                      <td>{a.phoneNo}</td>
                                      <td>{a.beneficiary}</td>
                                      <td>{a.beneficiaryPercentage}</td>
                                      <td>{a.funeralBenefits}</td>
                                      <td>{a.aliveOrDeceased}</td>
                                  </tr>
                              ))}
                          </tbody>
                      </Table>
                      </div>
                  ):(
                      <div className="text-center">
                          <div className="mb-4">
                          <i className="mdi mdi-check-circle-outline text-success display-4" />
                          </div>
                          <div>
                          <h5>No approval history found</h5>
                          <p className="text-muted">
                                  
                          </p>
                          </div>
                      </div>
                  )}
                </Col>
              </Row>                                
            </div>
          </Modal>
          <Modal isOpen={modal_qualifications} toggle={() => { tog_qualifications() }} centered size="xl">
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="myModalLabel">My Qualifications</h5>
                <button
                  type="button"
                  onClick={() => {
                    setmodal_qualifications(false);
                  }}
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">                                                       
              <Row >
                <Col lg={12}>
                  {(pQualifications.length > 0) ? (
                    <div className="table-responsive">
                      <Table className="table table-sm m-0">
                        <thead>
                          <tr>
                              <th>Qualification Code</th>
                              <th>Year of Award</th>
                              <th>Description</th>
                              <th>Institution</th>
                          </tr>
                        </thead>
                          <tbody>
                              {pQualifications.map((a,k)=>(
                                  <tr key={k}>
                                      <td>{a.qualificationCode}</td>
                                      <td>{a.yearOfAward}</td>
                                      <td>{a.description}</td>
                                      <td>{a.institution_Company}</td>
                                  </tr>
                              ))}
                          </tbody>
                      </Table>
                      </div>
                  ):(
                      <div className="text-center">
                          <div className="mb-4">
                          <i className="mdi mdi-school-outline text-warning display-4" />
                          </div>
                          <div>
                          <h5>No approval history found</h5>
                          <p className="text-muted">
                                  
                          </p>
                          </div>
                      </div>
                  )}
                </Col>
              </Row>            
            </div>
          </Modal>
          <Modal isOpen={modal_workexperience} toggle={() => { tog_workexperience() }} centered size="xl">
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="myModalLabel">My Work Experience</h5>
                <button
                  type="button"
                  onClick={() => {
                    setmodal_workexperience(false);
                  }}
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">                                                       
              <Row >
                <Col lg={12}>
                  {(pWorkExperience.length > 0) ? (
                    <div className="table-responsive">
                      <Table className="table table-sm m-0">
                        <thead>
                          <tr>
                              <th>Employer</th>
                              <th>Position</th>
                              <th>From Date</th>
                              <th>To Date</th>
                              <th>Sector</th>
                              <th>Reason for Leaving</th>
                              <th>Address</th>
                          </tr>
                        </thead>
                          <tbody>
                              {pWorkExperience.map((a,k)=>(
                                  <tr key={k}>
                                      <td>{a.employer}</td>
                                      <td>{a.employeePosition}</td>
                                      <td>{a.fromDate}</td>
                                      <td>{a.toDate}</td>
                                      <td>{a.Sector}</td>
                                      <td>{a.reasonForLeaving}</td>
                                      <td>{a.address}</td>
                                  </tr>
                              ))}
                          </tbody>
                      </Table>
                      </div>
                  ):(
                      <div className="text-center">
                          <div className="mb-4">
                          <i className="mdi mdi-home-search-outline text-warning display-4" />
                          </div>
                          <div>
                          <h5>No Work Experience Details found!</h5>
                          <p className="text-muted">
                                  
                          </p>
                          </div>
                      </div>
                  )}
                </Col>
              </Row>            
            </div>
          </Modal>

          <Row>
            <Col lg="12">
              {error && error ? <Alert color="danger">{error}</Alert> : null}
              {success ? <Alert color="success">{success}</Alert> : null}

              <Card>
                <CardBody>
                  <Row>
                    <Col xl ={4}>
                      <div className="d-flex align-self-center">
                      <div className="me-3">
                        <div className="avatar-md mx-auto mt-1">
                            <span className={ "avatar-title rounded-circle bg-soft bg-primary primary text-primary font-size-24"} >
                              {staffinitials}
                            </span>
                        </div>
                      </div>

                        <div className="flex-grow-1 align-self-center">
                          <div className="text-muted">
                            {/* <h5>{name}</h5> */}
                            <p className="mb-0">{idx}</p>
                            <p className="mb-0">{firstName}{" "}{middleName}{" "}{lastName}</p>
                            <p className="mb-0">{gender}</p>  
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col xl = {8}>
                        <div className="hstack gap-2">
                          <button className="btn btn-primary btn-block w-100" onClick={handleDependants}><i className="mdi mdi-open-in-new"/>{"  "}Dependants</button>    
                          <button className="btn btn-primary btn-block w-100" onClick={handleQualifications}><i className="mdi mdi-open-in-new"/>{"  "}Qualifications</button>    
                          <button className="btn btn-primary btn-block w-100" onClick={handleWorkExperience}><i className="mdi mdi-open-in-new"/>{"  "}Work Experience</button>
                          {/* <button className="btn btn-primary btn-block w-100" onClick={handleHRRelatedInformation}><i className="mdi mdi-open-in-new"/>{"  "}HR Related Information</button>              */}
                        </div> 
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="text-center">
                      Personal
                  </CardTitle>
                  <Card>
                    <CardBody >
                        <div className="table-responsive">
                        <Row>
                        <Col>
                        <CardTitle className="text-center">
                          <h6>Official</h6>
                        </CardTitle>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <th scope="col">Tax Identification No.</th>
                                    <td scope="col"> {tin} </td>
                                </tr>
                                <tr>
                                    <th scope="col">Social Security No</th>
                                    <td scope="col">{socialSecurity}</td>
                                </tr>
                                <tr>
                                    <th scope="col">National Identification No.</th>
                                    <td scope="col">{nin}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Religion</th>
                                    <td>{religion}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Religion Description</th>
                                    <td>{religiondescription}</td>
                                </tr> 
                            </tbody>
                        </table>
                        </Col>
                        <Col>
                        <CardTitle className="text-center">
                          <h6>Residential Physical Address</h6>
                        </CardTitle>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <th scope="col">Residence</th>
                                    <td scope="col"> {residence} </td>
                                </tr>
                                <tr>
                                    <th scope="col">Phy. LC. Zone</th>
                                    <td scope="col">{phyLCZone}</td>
                                </tr>
                                <tr>
                                    <th scope="col">Phy. Parish</th>
                                    <td scope="col">{phyParish}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Subcounty</th>
                                    <td>{subcounty}</td>
                                </tr>
                            </tbody>
                        </table>
                        </Col>
                        <Col>
                        <CardTitle className="text-center">
                          <h6>Place of Origin</h6>
                        </CardTitle>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <th scope="col">Village Address</th>
                                    <td scope="col"> {villageaddress} </td>
                                </tr>
                                <tr>
                                    <th scope="col">Village Parish</th>
                                    <td scope="col">{villageparish}</td>
                                </tr>
                                <tr>
                                    <th scope="col">Village Subcountry</th>
                                    <td scope="col">{villSubcounty}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Village District</th>
                                    <td>{villagedistrict}</td>
                                </tr>
                            </tbody>
                        </table>
                        </Col>
                        </Row>
                    </div>
                    {/* <div className="hstack gap-2">
                        <button className="btn btn-primary btn-block w-100" onClick={() => {history.push(`/create-application/${id}`)}}><i className="mdi mdi-open-in-new"/>{"  "}Apply Now</button>             
                    </div> */}
                    </CardBody>
                </Card>
                
              </CardBody>
            </Card>
            </Col>
          </Row>


          <Row>
            <Col lg="4">
              <Card>
                <CardBody>
                  <CardTitle className="text-center">
                    General
                  </CardTitle>
                <Card>     
                    <div className="table-responsive">
                      <table className="table">
                        <tbody>
                          <tr>
                              <th scope="col">Address</th>
                              <td scope="col"> {address} </td>
                          </tr>
                          <tr>
                              <th scope="row">Birthday</th>
                              <td>{birthday}</td>
                              
                          </tr>
                          <tr>
                              <th scope="col">Post Code</th>
                              <td scope="col">{postcode}</td>
                          </tr>
                          <tr>
                              <th scope="row">City</th>
                              <td>{city}</td>
                          </tr>
                          <tr>
                              <th scope="row">Country/Region</th>
                              <td>{country}</td>
                          </tr>
                          <tr>
                              <th scope="row">Marital Status</th>
                              <td>{maritalStatus}</td>
                          </tr> 
                          <tr>
                              <th scope="row">Probation Due Date</th>
                              <td>{probationDueDate}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* <div className="hstack gap-2">
                        <button className="btn btn-primary btn-block w-100" onClick={() => {history.push(`/create-application/${id}`)}}><i className="mdi mdi-open-in-new"/>{"  "}Apply Now</button>             
                    </div> */}
                </Card>
              </CardBody>
              </Card>
            </Col>
            
            <Col lg="4">
              <Card>
                <CardBody>
                  <CardTitle className="text-center">
                      Communication
                  </CardTitle>
                  <Card>
                        <div className="table-responsive">
                        <table className="table">
                            <tbody>
                                <tr>
                                    <th scope="col">Extension</th>
                                    <td scope="col"> {extension} </td>
                                </tr>
                                <tr>
                                    <th scope="col">Mobile Phone No.</th>
                                    <td scope="col">{mobilePhoneNo}</td>
                                </tr>
                                <tr>
                                    <th scope="col">Phone No.</th>
                                    <td scope="col">{phoneNo}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Email</th>
                                    <td>{email}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Company Email</th>
                                    <td>{companyEmail}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Initials</th>
                                    <td>{initials}</td>
                                </tr> 
                            </tbody>
                        </table>
                    </div>
                    {/* <div className="hstack gap-2">
                        <button className="btn btn-primary btn-block w-100" onClick={() => {history.push(`/create-application/${id}`)}}><i className="mdi mdi-open-in-new"/>{"  "}Apply Now</button>             
                    </div> */}
                </Card>
              </CardBody>
            </Card>
            </Col>

            <Col lg="4">
              <Card>
                <CardBody>
                  <CardTitle className="text-center">
                      Administration
                  </CardTitle>
                  <Card>
                    <CardBody >
                        <div className="table-responsive">
                        <table className="table">
                            <tbody>
                                <tr>
                                    <th scope="col">Employment Date</th>
                                    <td scope="col"> {employementDate} </td>
                                </tr>
                                <tr>
                                    <th scope="col">Department Code</th>
                                    <td scope="col">{departmentCode}</td>
                                </tr>
                                <tr>
                                    <th scope="col">Customer No.</th>
                                    <td scope="col">{customerNo}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Status</th>
                                    <td>{status}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Next Of Kin Name</th>
                                    <td>{nextofkinname}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Next Of Kin Relationship</th>
                                    <td>{nextofkinrelationship}</td>
                                </tr> 
                                <tr>
                                    <th scope="row">Next of Kin Office Address</th>
                                    <td>{nextofKinOfficeAddress}</td>
                                </tr> 
                                <tr>
                                    <th scope="row">Next of Kin Physical Address</th>
                                    <td>{nextofKinPhysicalAddress}</td>
                                </tr> 
                                <tr>
                                    <th scope="row">Next of Kin Home Postal Address</th>
                                    <td>{nextofKinHomePostalAddress}</td>
                                </tr> 
                                <tr>
                                    <th scope="row">Next of Place of Work</th>
                                    <td>{nextofPlaceofWork}</td>
                                </tr> 
                                <tr>
                                    <th scope="row">Next of Kin Work Phone</th>
                                    <td>{nextofKinWorkPhone}</td>
                                </tr> 
                            </tbody>
                        </table>
                    </div>
                    {/* <div className="hstack gap-2">
                        <button className="btn btn-primary btn-block w-100" onClick={() => {history.push(`/create-application/${id}`)}}><i className="mdi mdi-open-in-new"/>{"  "}Apply Now</button>             
                    </div> */}
                    </CardBody>
                </Card>
                
              </CardBody>
            </Card>
            </Col>
            </Row>
            
            
         
        </Container>
      </div>
    </React.Fragment>

  );
};

export default withRouter(UserProfile);
